import useScrollY from "./useScrollY";

/**
 * Translates its children vertically based on scroll position.
 *   speed: multiplier applied to scrollY. Positive values move UP as the
 *          page scrolls down (slower than scroll = feels farther away).
 *          Negative values move DOWN (closer to viewer).
 *          Typical ranges: 0.05 – 0.35 for backgrounds.
 *   className: extra classes for positioning.
 *
 * Respects prefers-reduced-motion (via useScrollY returning 0).
 */
export default function Parallax({ speed = 0.2, className = "", children, style = {} }) {
  const y = useScrollY();
  const offset = -y * speed;

  return (
    <div
      className={className}
      style={{
        transform: `translate3d(0, ${offset}px, 0)`,
        willChange: "transform",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
